// client/src/components/agent/ActionsPanel.jsx
import { useState, useEffect } from 'react';
import theme from '../../theme';
import ContactFieldsView from './actions/ContactFieldsView';
import QuickRepliesView from './actions/QuickRepliesView';
import InteractiveMessageView from './actions/InteractiveMessageView';
import CreateOrderView from './actions/CreateOrderView';
import PayLinkView from './actions/PayLinkView';
import StartConversationView from './actions/StartConversationView';

export default function ActionsPanel({ token, conv, contact, company, onContactUpdated, isMobile, onBack, width }) {
  const [view, setView] = useState('menu');
  const c = theme.colors;

  // Al cambiar de conversación, la vista se conserva pero los datos se re-vinculan
  // (cada sub-vista re-carga por su cuenta vía useEffect sobre conv/contact).
  // Si se queda sin conversación activa, volvemos al menú: las vistas que dependen
  // de una conversación (pedido, link de pago, datos del usuario) no deben quedar abiertas.
  useEffect(() => {
    if (!conv && (view === 'pedido' || view === 'paylink' || view === 'contacto')) {
      setView('menu');
    }
  }, [conv, view]);

  const w = width || 280;
  const panelStyle = isMobile
    ? { width: '100%', borderLeft: `1px solid ${c.border}`, background: c.surface, display: 'flex', flexDirection: 'column', overflow: 'hidden' }
    : { width: w, minWidth: w, flexShrink: 0, borderLeft: `1px solid ${c.border}`, background: c.surface, display: 'flex', flexDirection: 'column', overflow: 'hidden' };

  const canStart = !!company?.agents_can_start;
  const canPayLink = !!company?.has_pasarela;

  const MenuButton = ({ id, label }) => (
    <button onClick={() => setView(id)}
      style={{ display: 'block', width: '100%', textAlign: 'left', padding: '12px 14px', background: c.background, color: c.text, border: `1px solid ${c.border}`, borderRadius: 8, cursor: 'pointer', marginBottom: 8, fontSize: 14 }}>
      {label}
    </button>
  );

  const back = () => setView('menu');

  return (
    <div style={panelStyle}>
      {view === 'menu' && (
        <div style={{ padding: 12 }}>
          {isMobile && (
            <button onClick={onBack}
              style={{ background: 'transparent', border: `1px solid ${c.border}`, color: c.text, borderRadius: 6, padding: '6px 12px', cursor: 'pointer', marginBottom: 12 }}>
              ← Volver
            </button>
          )}
          {!conv && (
            <div style={{ color: c.textMuted, fontSize: 12, lineHeight: 1.5, marginBottom: 12 }}>
              No tienes una conversación seleccionada. Puedes iniciar una nueva o revisar tus textos y media rápidos mientras llegan conversaciones.
            </div>
          )}
          <MenuButton id="archive" label="📎 Textos y media rápidos" />
          <MenuButton id="interactivo" label="💬 Textos interactivos" />
          {conv && <MenuButton id="pedido" label="🛒 Crear pedido" />}
          {conv && canPayLink && <MenuButton id="paylink" label="💳 Generar link de pago" />}
          {canStart && <MenuButton id="iniciar" label="✉️ Iniciar conversación" />}
          {conv && <MenuButton id="contacto" label="🗂️ Datos grabados del usuario" />}
        </div>
      )}
      {view === 'archive' && (
        <QuickRepliesView token={token} conv={conv} onBack={back} />
      )}
      {view === 'interactivo' && (
        <InteractiveMessageView token={token} conv={conv} onBack={back} />
      )}
      {view === 'contacto' && (
        <ContactFieldsView token={token} contact={contact} onBack={back} onSaved={onContactUpdated} />
      )}
      {view === 'pedido' && (
        <CreateOrderView token={token} conv={conv} onBack={back} />
      )}
      {view === 'paylink' && (
        <PayLinkView token={token} conv={conv} onBack={back} />
      )}
      {view === 'iniciar' && (
        <StartConversationView token={token} onBack={back} />
      )}
    </div>
  );
}
